// fake iPhone data to be displayed as products in the Product component

const DATA = [
	{
		id: 0,
		title: "iPhone 11",
		price: 750,
		desc: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.",
		img: "/images/iPhones/iPhone11.jpg",
	},
	{
		id: 1,
		title: "iPhone 11 Pro Max",
		price: 800,
		desc: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.",
		img: "/images/iPhones/iPhone11ProMax.jpeg",
	},
	{
		id: 2,
		title: "iPhone 12 Mini",
		price: 950,
		desc: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.",
		img: "/images/iPhones/iPhone12Mini.jpg",
	},
	{
		id: 3,
		title: "iPhone 12",
		price: 1050,
		desc: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.",
		img: "/images/iPhones/iPhone12.jpg",
	},
	{
		id: 4,
		title: "iPhone 12 Pro",
		price: 1150,
		desc: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.",
		img: "/images/iPhones/iPhone12Pro.jpg",
	},
	{
		id: 5,
		title: "iPhone 12 Pro Max",
		price: 1250,
		desc: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.",
		img: "/images/iPhones/iPhone12ProMax.png",
	},
];

export default DATA;
